import { CustomTextArea } from '../../../../common/CustomTextArea';
import CustomTextField from '../../../../common/CustomTextField';
import {
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';

const EmbryologyClinicalPregDetails = ({
  embryoTransferDetails,
  handleInputChange,
}) => {
  return (
    <div className="card">
      <h3 style={{ textAlign: 'center' }}>Clinical Pregnancy Details</h3>

      <div className="body" style={{ display: 'flex', gap: '10px' }}>
        <table
          cellPadding={'20px'}
          style={{ flexGrow: 1, padding: '0px 10px' }}
        >
          <tbody>
            <tr>
              <td>Number of SAC</td>
              <td>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={embryoTransferDetails.noOfSAC}
                  name={'noOfSAC'}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </td>
              <td>Clinical Pregnancy (0/1)</td>
              <td>
                {renderDropdownWithoutLabel(
                  'clinicalPregnancyDetailsClinical',
                  embryoTransferDetails.clinicalPregnancyDetailsClinical,
                  [' ', '0', '1'],
                  handleInputChange,
                )}
              </td>
              <td>FHR (0/1)</td>
              <td>
                {renderDropdownWithoutLabel(
                  'FHR',
                  embryoTransferDetails.FHR,
                  [' ', '0', '1'],
                  handleInputChange,
                )}
              </td>
            </tr>

            <tr>
              <td>Ectopic Pregnancy/Misccariage</td>
              <td>
                {renderDropdownWithoutLabel(
                  'ectopic',
                  embryoTransferDetails.ectopic,
                  [' ', '0', '1'],
                  handleInputChange,
                )}
              </td>
              <td>Ongoing Pregnancy (0/1)</td>
              <td>
                {renderDropdownWithoutLabel(
                  'ongoingPregnancy',
                  embryoTransferDetails.ongoingPregnancy,
                  [' ', '0', '1'],
                  handleInputChange,
                )}
              </td>
              <td>Comments</td>
              <td>
                <CustomTextArea
                  minRows={2}
                  maxRows={3}
                  value={embryoTransferDetails.clinicalPregnancyDetailsComments}
                  onChange={handleInputChange}
                  name="clinicalPregnancyDetailsComments"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default EmbryologyClinicalPregDetails;
